import React, { useState, useEffect } from 'react';
import styles from './viewSingleCandidate.module.scss';
import { Col, Row, Accordion, Card, Modal, Button, Image, Alert, Container, Badge, Tab, Tabs } from 'react-bootstrap';
import CSSLoader from '../../../../../shared/cssLoader';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { candidateRejectOffer, failFilteredCandidates, getCandidateDetails, getPresignedUrlToViewCandidateCV, markAsCandidateHired, markAsOfferSentAPI } from '../../../../../../services/util/hiringpipeline/candidates';
import { Document, Page } from 'react-pdf';
import { failCandidateManually, passCandidateManually, passFailedCandidateManually } from '../../../../../../services/util/hiringpipeline/candidates';
import { useHistory } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../../../../customNavbar';
import { CustomButton } from '../../../../../shared/customButton';
import { CustomAlertBox } from '../../../../../shared/customAlertBox';
import { CustomConfirmationModal } from '../../../../../shared/customConfirmationModal';
import { CustomConfirmationBox } from '../../../../../shared/customConfirmationBox';
import moment from 'moment';
import { checkCompanyEmailAccountConnection } from '../../../../../../services/util/company';
import SendEmailModal from './sendEmailModal';
import AddCandiateNoteModal from '../../../../common/addCandidateSpecialNoteModal'
import SubmitOfferModal from './../../../../offerHandling/submitOfferModal';
import ViewAssessmentModal from './viewAssessmentModal';
import ExtendAssessmentTimeModal from './ExtendAssessmentTimeModal';
import ExtendQuizTimeModal from './ExtendQuizTimeModal';
import CandidateCvView from '../../../../common/candidateCvView';
import CandidateSpecialNotesView from '../../../../common/candidateSpecialNotesView'
import CandidateCoverLetterView from '../../../../common/candidateCoverLetterView';
import CandidateAnswersToCustomQuestionsView from '../../../../common/candidateAnswersToCustomQuestionsView';
import CandidateEvaluationFlow from './candidateEvaluationFlow';
import Avatar from 'react-avatar';
import StarRating from '../../../../../shared/rate'


const ViewSingleCandidate = (props) => {
    let [isLoading, setLoading] = useState(true);
    let [accordionIcon, setAccordionIcon] = useState({
        rowid: '',
        icon: false
    });
    let [accordionIconForCustomQuestions, setAccordionIconForCustomQuestions] = useState({
        icon: false
    })
    const [showCVModal, setShowCVModal] = useState(false);
    let [numPages, setNumPages] = useState(null);
    const [defaultScalePrecentage, setScalePrecentage] = useState(100);
    const [defaultScale, setDefaultScale] = useState(1.6);
    let [pageNumber, setPageNumber] = useState(1);
    const [cvObject, setCVObject] = useState({ url: null });
    let [candidateValues, setCandidateValues] = useState({
        candidate_email: '',
        candidate_name: '',
        candidate_phone: '',
        current_state: '',
        current_stage_id: '',
        current_stage_name: null,
        hiring_position: '',
        is_special_source: false,
        overall_score: '',
        review_criteria: [],
        photo_url: '',
        pipeline_name: '',
        special_source: '',
        special_source_additional_data: '',
        available_date: '',
        expected_salary: '',
        expected_salary_paid_by: '',
        custom_question_answers: '',
        cover_letter_url: '',
        cv_url: '',
        custom_question_answers: []

    });

    let [hiringFlow, setHiringFlow] = useState({
        evaluation_stages: {
            state: 0,
            steps: []
        },
        filter_stage: null,
        hire_stage: null,
        offer_stage: null
    });

    //Actions Modal states
    let [actionStateModal, setActionStateModal] = useState({
        is_open: false,
        candidate_id_set: [],
        action_state: ''
    });

    //Actions Submit Loading
    let [actionsSubmitLoading, setActionsSubmitLoading] = useState(false);

    //let failed pipeline step id
    let [failedPipelineStepID, setFailedPipelineStepID] = useState('');

    let [sendEmailButtonDisabled, setSendEmailButtonDisabled] = useState(false);
    let [sendEmailModalOpen, setSendEmailModalOpen] = useState(false);
    let [emailConnectedModal, setEmailConnectedModal] = useState(false);
    let [isURLLoading, setURLLoading] = useState(false);

    //states for open modal for view assessment
    let [showViewAssessmentModal, setShowViewAssessmentModal] = useState(false);
    let [modalAssessmentData, setModalAssessmentData] = useState();

    //states for oprn and set data for quiz time extending modal
    let [showExtendQuizTimeModal, setshowExtendQuizTimeModal] = useState(false);
    let [quizTimeExtendingModalData, setQuizTimeExtendingModalData] = useState();

    //states for oprn and set data for assessment time extending modal
    let [showExtendAssessmentTimeModal, setShowExtendAssessmentTimeModal] = useState(false);
    let [assessmentTimeExtendingModalData, setAssessmentTimeExtendingModalData] = useState();


    let [isDownloadCVPending, setIsDownloadCVPending] = useState(false);
    let [isViewCVPending, setIsViewCVPending] = useState(false);

    let [activeTabKey, setActiveTabKey] = useState("evaluationDetails")
    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };
    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let [candidateID, setCandidateID] = useState(params.get('cid'));
    const history = useHistory();
    let moment = require('moment-timezone');

    const breadcrumb = [
        {
            pathaddress: '',
            pathname: 'Candidates',
            isActive: true,
            key: 'candidates'
        },
        {
            pathaddress: '',
            pathname: candidateValues.candidate_name,
            isActive: true,
            key: candidateValues.candidate_name
        }
    ]

    // Evaluation Stages
    const MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION = '10';
    const MANUALLY_REJECT_IN_EVALUATION = '20';
    const MANUALLY_PASS_FROM_FAILED_IN_EVALUATION = '30';
    // Filtered Stage
    const MARK_AS_OFFER_SENT_IN_FILTERD_STAGE = '110';
    const REJECT_IN_FILTERD_STAGE = '120';
    //Offer sent stage
    const MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE = '210';
    const MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE = '220';

    // functions

    function handleCVViewModalClose() {
        setShowCVModal(false);
    }

    //on pdf load success
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    const getCandidateAllDetails = async () => {
        setLoading(true)
        let respond = await getCandidateDetails(candidateID);
        if (respond.success === true) {
            setCandidateValues(respond.data.candidate_details);
            setHiringFlow(respond.data.hiring_flow);
            setLoading(false)
        } else {
            setLoading(false)
            history.push(`/app/company/pipelines/${candidateValues.hiring_pipeline._id}`)
        }
    }

    const zoomin = () => {
        if (defaultScale < 2) {
            setDefaultScale(defaultScale + 0.2);
            setCvViewprecentage((defaultScale + 0.2));
        }

    }
    const zoomout = () => {
        if (defaultScale > 1.0000000000000002) {
            setDefaultScale(defaultScale - 0.2);
            setCvViewprecentage((defaultScale - 0.2));
        }
    }

    const setCvViewprecentage = (value) => {
        //check scale value and change precentage value according to scale value
        setScalePrecentage(value === 2 ? 150 : value === 1.8 ? 125 : value === 1.6 ? 100 : value === 1.4000000000000001 ? 75 : value === 1.2000000000000002 ? 50 : value === 1.0000000000000002 ? 25 : 0)
    }

    function nextPage() {
        if (pageNumber !== numPages) {
            setPageNumber(prevState => prevState + 1);
        }
    }

    function prevPage() {
        if (pageNumber !== 1) {
            setPageNumber(prevState => prevState - 1);
        }
    }

    //on action selected
    const onActionSelected = async (action_id, data_values) => {
        let candidate_id_array = [];
        candidate_id_array.push(data_values);

        if (action_id === MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_REJECT_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_REJECT_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_PASS_FROM_FAILED_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_FROM_FAILED_IN_EVALUATION
            });
        }
        if (action_id === MARK_AS_OFFER_SENT_IN_FILTERD_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MARK_AS_OFFER_SENT_IN_FILTERD_STAGE
            });
        }
        if (action_id === REJECT_IN_FILTERD_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: REJECT_IN_FILTERD_STAGE
            });
        }
        if (action_id === MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE
            });
        }
        if (action_id === MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE
            });
        }
    };

    //failcandidates from current pipeline step
    const manuallyFailFromCurrentStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failCandidateManually(actionStateModal.candidate_id_set, candidateValues.current_stage_id, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
            props.GetTaskValues();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //pass candidates to next evaluation step
    const manualPassToNextStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await passCandidateManually(actionStateModal.candidate_id_set, candidateValues.current_stage_id, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
            props.GetTaskValues();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //manually pass failed candidate to next step
    const manuallyPassFailedCandidateFromStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await passFailedCandidateManually(actionStateModal.candidate_id_set, failedPipelineStepID, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setFailedPipelineStepID('');
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
            props.GetTaskValues();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //mark as offer sent
    const markAsOfferSent = async () => {
        setActionsSubmitLoading(true);
        let respond = await markAsOfferSentAPI(actionStateModal.candidate_id_set);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //manually fail from filter step
    const manuallyFailFromFilterStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failFilteredCandidates(actionStateModal.candidate_id_set, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
            props.GetTaskValues();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //reject sent offer
    const rejectOffer = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await candidateRejectOffer(actionStateModal.candidate_id_set, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //mark as hired candidate
    const markCandidateAsHired = async () => {
        setActionsSubmitLoading(true);
        let respond = await markAsCandidateHired(actionStateModal.candidate_id_set);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            getCandidateAllDetails();
        } else {
            setActionsSubmitLoading(false);
        }
    }

    function redirectToCompanySettings() {
        window.location.replace('/app/company/settings/integrations')
    }



    const sendEmailButtonClick = async () => {
        setSendEmailButtonDisabled(true);
        let respond = await checkCompanyEmailAccountConnection();
        if (respond.success === true) {
            if (respond.data.is_company_ready_for_email_automation) {
                setSendEmailModalOpen(true)
            } else {
                setEmailConnectedModal(true);
            }
            setSendEmailButtonDisabled(false);
        } else {
            setSendEmailButtonDisabled(false);
        }
    }

    //refresh data after submit offer
    const refreshDataAfterSubmitOffer = async () => {
        getCandidateAllDetails();
    };


    const setModalClose = () => {
        setShowViewAssessmentModal(false);
        setshowExtendQuizTimeModal(false);
        setShowExtendAssessmentTimeModal(false);
    }

    const downloadCVClick = async () => {
        setIsDownloadCVPending(true);
        let respond = await getPresignedUrlToViewCandidateCV(candidateID);
        if (respond.success === true) {
            if (respond.data.presigned_url) {
                setIsDownloadCVPending(false);
                window.open(respond.data.presigned_url)
            } else {
                setIsDownloadCVPending(false);
            }
        } else {
            setIsDownloadCVPending(false);
        }
    }

    const viewCVClick = async () => {
        setIsViewCVPending(true);
        let respond = await getPresignedUrlToViewCandidateCV(candidateID);
        if (respond.success === true) {

            if (respond.data.presigned_url) {
                setIsViewCVPending(false);
                setCVObject(respond.data.presigned_url);
                setShowCVModal(true);
            } else {
                setIsViewCVPending(false);
            }
        } else {
            setIsViewCVPending(false);
        }
    }

    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const closeSpecialNoteModal = () => {
        setSpecialNoteModalOpen(false);
    }

    useEffect(() => {
        if (candidateID) {
            getCandidateAllDetails();
        }
    }, []);

    useEffect(() => {
        let pageHit = '/app/company/pipeline/view-candidate-profile';
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])

    return (
        <div className={styles.bodyDiv}>
            <Helmet>
                <title>View Candidate | HireTrace</title>
            </Helmet>

            {/* Manually fail pipeline step confirmation popup box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_REJECT_IN_EVALUATION}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={manuallyFailFromCurrentStep}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to manually reject selected candidate from the pipeline. Candidate overall status will be failed."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, reject candidate"
                checkboxLabel="I confirm to manually reject selected candidate from the pipeline"
            />
            {/* Manually fail pipeline step confirmation popup box end */}


            {/* Manually pass pipeline step confirmation popup box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={manualPassToNextStep}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to manually pass selected candidate from current stage to the next stage."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, pass step!"
                checkboxLabel="I confirm to manually pass selected candidate from pipeline step"
            />
            {/* Manually pass pipeline step confirmation popup box end */}


            {/* Manually pass failed candidate confirmation box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_PASS_FROM_FAILED_IN_EVALUATION}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={manuallyPassFailedCandidateFromStep}

                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to manually pass selected candidate(s) from current stage to the next stage."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, pass step!"
                checkboxLabel="I confirm to manually pass selected candidate(s) from pipeline step"
            />
            {/* Manually pass failed candidate confirmation box end */}


            {/* Mark as offer sent from filtered step confirmation popup box start */}
            {/* <CustomConfirmationModal
                show={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_SENT_IN_FILTERD_STAGE}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onPrimaryBtnClick={markAsOfferSent}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are manually passing selected candidate from filtered stage to the offer stage."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, pass step!"
            /> */}
            {/*  Mark as offer sent from filtered step confirmation popup box end */}

            {/* Manually fail from filter step confirmation popup box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === REJECT_IN_FILTERD_STAGE}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={manuallyFailFromFilterStep}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to manually reject selected candidate from the pipeline. Candidate overall status will be failed."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, reject candidate"
                checkboxLabel="I confirm to manually reject selected candidate from the pipeline"
            />
            {/* Manually fail from filter step confirmation popup box end */}

            {/* Mark as candidate reject offer confirmation popup box start */}
            <CustomConfirmationBox
                show={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE}
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onFormSubmit={rejectOffer}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to mark selected candidate rejected sent offer. Candidate overall status will be failed."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, reject candidate"
                checkboxLabel="I confirm to mark as selected candidate is rejected sent offer"
            />
            {/* Mark as candidate reject offer confirmation popup box end */}

            {/* Pass to hired step confirmation popup box start */}
            <CustomConfirmationModal
                show={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE}
                confirmationType='success'
                cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                onPrimaryBtnClick={markCandidateAsHired}
                isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage="You are marking selected candidate is hired."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, pass step!"
            />
            <SubmitOfferModal
                showModal={actionStateModal.is_open && actionStateModal.action_state === MARK_AS_OFFER_SENT_IN_FILTERD_STAGE}
                handleClose={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                candidateID={candidateID}
                refreshData={refreshDataAfterSubmitOffer}
                GetTaskValues={props.GetTaskValues}
            />

            {/* Pass to hired step confirmation popup box end */}

            {/* SHOW CV Modal Start */}
            <Modal
                show={showCVModal}
                onHide={handleCVViewModalClose}
                backdrop="static"
                keyboard={false}
                centered
                size="xl"
                scrollable
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={handleCVViewModalClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <Container className={styles.actionBtnRow}>
                        <Card className={styles.cvViewCard}>
                            <Card.Header className={styles.cardHeaderCvView}>
                                <div className={styles.headerDetails}>
                                    <p className={styles.accordianHeaderTopic}>CV of&nbsp;&nbsp;{candidateValues.candidate_name}</p>
                                    <div className={styles.pdfcomponentActions}>
                                        <div className={styles.cvZoomcomponent}>
                                            <Button className={styles.zoomBtn} onClick={() => zoomout()} disabled={defaultScalePrecentage === 25 ? true : false}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M15.75 15.7498L12.4875 12.4873" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6 8.25H10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                            <span className="ml-2 mr-2">{defaultScalePrecentage}%</span>
                                            <Button className={styles.zoomBtn} onClick={() => zoomin()} disabled={defaultScalePrecentage === 150 ? true : false}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M15.75 15.7498L12.4875 12.4873" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.25 6V10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6 8.25H10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                        </div>
                                        <div className={styles.pageChangerComponent}>
                                            <Button className={styles.pageMoveBtn} disabled={pageNumber === 1 ? true : false} onClick={() => prevPage()}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15 6L9 12L15 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                            <span className="ml-2 mr-2"><span>{pageNumber}/{numPages}</span></span>
                                            <Button className={styles.pageMoveBtn} disabled={pageNumber === numPages ? true : false} onClick={() => nextPage()}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body className={styles.cvViewBody}>
                                <Document
                                    file={cvObject}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    options={options}
                                    loading={<div>
                                        <Col sm={{ span: 4, offset: 4 }}>
                                            <CSSLoader />
                                        </Col>
                                    </div>}
                                >

                                    <Page pageNumber={pageNumber} scale={defaultScale} />
                                </Document>
                            </Card.Body>
                        </Card>
                    </Container>
                </Modal.Body>
            </Modal>

            {/* Modal End */}

            {/* email connection Modal Start*/}

            <Modal
                show={emailConnectedModal}
                onHide={() => setEmailConnectedModal(false)}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBody}>

                    <div className={styles.popUpBoxTopicDiv}>
                        <p className={styles.popUpBoxTopic}>Connect Company Email</p>
                    </div>
                    <Container>
                        <Col>
                            <p className={styles.popUpBoxMessage}>Company email haven't configured.</p>
                        </Col>
                        <Col>
                            <p className={styles.popUpBoxMessageDesc}>Before sending email, connect one of your organization’s Google or Office 365 Email Accounts (ex :- careers@companyxxx.com). </p>
                        </Col>
                        <Container>
                            <Row>
                                <Col className="mb-2">
                                    <CustomButton
                                        name="respondAcceptBtn"
                                        buttonType="button"
                                        type="defaultBtn"
                                        label="Cancel"
                                        handleClick={() => setEmailConnectedModal(false)}
                                    />
                                </Col>
                                <Col>
                                    <CustomButton
                                        name="respondAcceptBtn"
                                        buttonType="button"
                                        type="primaryBtn"
                                        label="Connect Email"
                                        handleClick={redirectToCompanySettings}
                                    />
                                </Col>
                            </Row>
                        </Container>

                    </Container>
                </Modal.Body>
            </Modal>
            {specialNoteModalOpen &&
                <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={candidateID} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* email connection Modal end*/}

            {/* send email Modal start*/}
            {sendEmailModalOpen &&
                <SendEmailModal showModal={sendEmailModalOpen} handleClose={() => setSendEmailModalOpen(false)} candidateID={candidateID} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* send email Modal end*/}
            {/* view assessment Modal start */}
            {
                showViewAssessmentModal === true &&
                <ViewAssessmentModal showDetailsModal={showViewAssessmentModal} assessmentData={modalAssessmentData} modalClose={setModalClose} />
            }
            {/* view assessment modal end */}
            {/* view Time Extending Modal start */}
            {
                showExtendQuizTimeModal &&
                <ExtendQuizTimeModal showDetailsModal={showExtendQuizTimeModal} modalClose={setModalClose} quizData={quizTimeExtendingModalData} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* view Time Extending modal end */}
            {/* view Time Extending Modal start */}
            {
                showExtendAssessmentTimeModal &&
                <ExtendAssessmentTimeModal showDetailsModal={showExtendAssessmentTimeModal} modalClose={setModalClose} assessmentData={assessmentTimeExtendingModalData} getCandidateAllDetails={getCandidateAllDetails} />
            }
            {/* view Time Extending modal end */}

            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>

                    <Col sm={12} className={styles.mainContainer}>
                        {/* candidate review details */}
                        <Row>
                            <Col>
                                <div className={styles.reviewDetails}>
                                    <Row>
                                        <Col md={1} lg={1} xl={1} className={styles.candidatePhoto}>
                                            <Avatar src={candidateValues.photo_url} name={candidateValues.candidate_name} size="90" round={false} />
                                        </Col>
                                        <Col md={9} lg={9} xl={9} className={styles.candidateDetails}>
                                            <Row>
                                                <Col sm={5}>
                                                    <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Name : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_name}</span></p>
                                                    <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Email : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_email}</span></p>
                                                    <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Phone : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_phone ? candidateValues.candidate_phone : 'Not available'}</span></p>
                                                </Col>
                                                <Col sm={5}>
                                                    <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue}>{candidateValues.pipeline_name}</span></p>
                                                    <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue}>{candidateValues.hiring_position}</span></p>
                                                    <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Salary Expectation : </span><span className={styles.reviewDetailsValue}>{candidateValues.expected_salary ? candidateValues.expected_salary : 'Not available'}&nbsp;{candidateValues.expected_salary_paid_by && candidateValues.expected_salary_paid_by === 10 ? "(Hourly)" : candidateValues.expected_salary_paid_by === 20 ? "(Daily)" : candidateValues.expected_salary_paid_by === 30 ? "(Weekly)" : candidateValues.expected_salary_paid_by === 40 ? "(FortNight)" : candidateValues.expected_salary_paid_by === 50 ? "(Monthly)" : ''}</span></p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={5}>
                                                    <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Available Date : </span><span className={styles.reviewDetailsValue}>{candidateValues.available_date ? moment(candidateValues.available_date).format("YYYY-MM-DD") : 'Not available'}</span></p>
                                                    {candidateValues.special_source &&
                                                        <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>{candidateValues.special_source ? candidateValues.special_source : null} : </span><span className={styles.reviewDetailsValue}>{candidateValues.special_source_additional_data.name ? candidateValues.special_source_additional_data.name : 'Not available'}</span></p>
                                                    }
                                                </Col>
                                                {candidateValues.current_stage_name &&
                                                <Col sm={5}>
                                                        <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Current Stage : </span><span className={styles.reviewDetailsValue}>{candidateValues.current_stage_name ? candidateValues.current_stage_name : 'Not available'}</span></p>
                                                </Col>
                                                }
                                                {candidateValues.current_state === 65 &&
                                                    <Col sm={5}>
                                                        <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Current Stage : </span>
                                                            <span className={styles.reviewDetailsValue}>Hired (Pushed to HRIS)</span></p>
                                                    </Col>
                                                }
                                                {candidateValues.current_state === 60 &&
                                                    <Col sm={5}>
                                                        <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Current Stage : </span>
                                                            <span className={styles.reviewDetailsValue}>Hired (Onboarded)</span></p>
                                                    </Col>
                                                }
                                                {candidateValues.current_state === 40 &&
                                                    <Col sm={5}>
                                                        <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Current Stage : </span>
                                                            <span className={styles.reviewDetailsValue}>Hired (Pending Onboarding)</span></p>
                                                    </Col>
                                                }
                                                {candidateValues.current_state === 30 &&
                                                    <Col sm={5}>
                                                        <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Current Stage : </span>
                                                            <span className={styles.reviewDetailsValue}>Offer</span></p>
                                                    </Col>
                                                }
                                                {candidateValues.current_state === 10 &&
                                                    <Col sm={5}>
                                                        <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Current Stage : </span>
                                                            <span className={styles.reviewDetailsValue}>Filtered</span></p>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                        <Col lg={2} >
                                        <div>
                                            {(candidateValues.current_state === 40 || candidateValues.current_state === 60 || candidateValues.current_state === 65) &&
                                                <Alert variant="success" className={styles.successAlert}>
                                                    <p className="mb-0">Hired</p>
                                                    <p className={styles.hiredDateLabel}>{hiringFlow.hire_stage ? hiringFlow.hire_stage.hired_date : ''}</p>
                                                </Alert>
                                            }
                                            {candidateValues.current_state === -10 &&
                                                <Alert variant="danger" className={styles.failAlert}>Rejected</Alert>
                                            }
                                            {candidateValues.current_state === -30 &&
                                                <Alert variant="danger" className={styles.failAlert}>Rejected at Offer Stage</Alert>
                                            }
                                            {candidateValues.current_state === 0 &&
                                                <Alert variant="warning" className={styles.pendingAlert}>Pending Evaluation</Alert>
                                            }
                                            {candidateValues.current_state === 10 &&
                                                <Alert variant="warning" className={styles.pendingAlert}>Pending Filter</Alert>
                                            }
                                            {(candidateValues.current_state === 30) &&
                                                <Alert variant="warning" className={styles.pendingAlert}>Offer Processing</Alert>
                                            }
                                            {candidateValues.current_state === -50 &&
                                                <Alert variant="danger" className={styles.failAlert}>Rejected at Onboarding</Alert>
                                            }

                                        </div>
                                        <div className={styles.actionBtnBoxNormal}>

                                            <div>
                                                <CustomButton
                                                    buttonType="button"
                                                    label="Send Email"
                                                    type="defaultBtn"
                                                    handleClick={() => sendEmailButtonClick()}
                                                    disabled={sendEmailButtonDisabled ? true : false}
                                                    backicon={sendEmailButtonDisabled && <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>}
                                                    frontIcon={<i class="fas fa-envelope"></i>}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={7} lg={8} xl={9}>
                                {/* view cv , cover letter and Custom Questions  */}
                                <Tabs
                                    activeKey={activeTabKey}
                                    id="controlled-tab-example"
                                    onSelect={(e) => setActiveTabKey(e)}
                                    className={styles.subtopic}
                                >
                                    <Tab eventKey="evaluationDetails" title="Evaluation Details" tabClassName={styles.tabcontent}>
                                        {/* <CandidateCoverLetterView candidateValues={candidateValues} stepId={id} coverLetterURL={candidateValues.cover_letter_url} /> */}

                                        <br></br>
                                        <CandidateEvaluationFlow hiringFlow={hiringFlow} candidateValues={candidateValues} candidateID={candidateID} permissions={props.permissions} getCandidateAllDetails={getCandidateAllDetails} GetTaskValues={props.GetTaskValues} />

                                    </Tab>
                                    <Tab eventKey="cv" title="CV" tabClassName={styles.tabcontent} >
                                        <CandidateCvView candidateValues={candidateValues} cvURL={candidateValues.cv_url} candidateID={candidateID}
                                        />
                                    </Tab>
                                    {candidateValues.cover_letter_url ?
                                        <Tab eventKey="CoverLetter" title="Cover Letter" tabClassName={styles.tabcontent}>
                                            <CandidateCoverLetterView candidateValues={candidateValues} coverLetterURL={candidateValues.cover_letter_url} candidateID={candidateID} />
                                        </Tab>
                                        : null}
                                    {candidateValues.custom_question_answers && candidateValues.custom_question_answers.length > 0 ?
                                        <Tab eventKey="customQuestions" title="Answers For Custom Questions" tabClassName={styles.tabcontent}>
                                            <CandidateAnswersToCustomQuestionsView candidateValues={candidateValues} />
                                        </Tab>
                                        : null}
                                    <Tab eventKey="specialNotes" title={"Special Notes "+"("+`${candidateValues.special_notes.length ? candidateValues.special_notes.length : "0"}`+")"} tabClassName={styles.tabcontent}>
                                        <CandidateSpecialNotesView candidateValues={candidateValues} candidateID={candidateID} openSpecialNoteModal={openSpecialNoteModal} closeSpecialNoteModal={closeSpecialNoteModal} />
                                    </Tab>
                                </Tabs>
                                {activeTabKey === "evaluationDetails" && <div>
                                    {/* Filter stage */}
                                    <Card className={hiringFlow.filter_stage ? styles.customCardFilterStage : styles.customCardFilterStageDisabled}>
                                        <Card.Header className={hiringFlow.filter_stage ? styles.customCardHeaderFilterStage : styles.customCardHeaderFilterStageDisabled}>
                                            <Col>
                                                <Row>
                                                    <Col sm={5} className="align-self-center">
                                                        <span>FILTERED STAGE DETAILS</span>
                                                    </Col>
                                                    {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 0 &&
                                                        <Col sm={{ offset: 2 }}>
                                                            <div>
                                                                <Button className={styles.actionBtnCurrentStepPass} onClick={() => onActionSelected(MARK_AS_OFFER_SENT_IN_FILTERD_STAGE, candidateID)} disabled={props.permissions.is_enabled === false && props.role === 1 ? true : false}>Prepare Offer</Button>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 0 &&
                                                        <Col>
                                                            <div>
                                                                <Button className={styles.actionBtnCurrentStepFail} onClick={() => onActionSelected(REJECT_IN_FILTERD_STAGE, candidateID)} disabled={props.permissions.is_enabled === false && props.role === 1 ? true : false}>Reject Candidate</Button>
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                            </Col>
                                        </Card.Header>
                                        <Card.Body>
                                            {hiringFlow.filter_stage && <Row className="ml-0 mr-0">
                                                <Col>
                                                    <Row>
                                                        <Col md={4}>
                                                            <p className={styles.userDetailsTopicLabels}>Reviewer Name </p>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.userDetailsData}>{hiringFlow.filter_stage && hiringFlow.filter_stage.action_by_name ? hiringFlow.filter_stage.action_by_name : 'Not Available'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={4}>
                                                            <p className={styles.userDetailsTopicLabelsBottom}>Email </p>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.userDetailsDataBottom}>{hiringFlow.filter_stage && hiringFlow.filter_stage.action_by_email ? hiringFlow.filter_stage.action_by_email : 'Not Available'}</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col lg={4}>
                                                    {hiringFlow.filter_stage && hiringFlow.filter_stage.state === -20 &&
                                                        <div>
                                                            <p className={styles.userDetailsTopicLabels}>Reject Reason</p>
                                                            <span className={styles.reviewersComments}><i className="fas fa-circle"></i>&nbsp;{hiringFlow.filter_stage.reject_reason}</span>
                                                        </div>
                                                    }
                                                </Col>
                                                <Col lg={2} className="align-self-center">
                                                    {hiringFlow.filter_stage && hiringFlow.filter_stage.state === 0 ?
                                                        <Alert variant="warning" className={styles.badgeTypeWarning}>Pending</Alert>
                                                        : hiringFlow.filter_stage && hiringFlow.filter_stage.state === -20 ?
                                                            <Alert variant="danger" className={styles.badgeTypeFail}>Failed</Alert>
                                                            : hiringFlow.filter_stage && hiringFlow.filter_stage.state === 10 ?
                                                                <Alert variant="success" className={styles.badgeType}>Offer Submitted for Approval</Alert>
                                                                : null
                                                    }

                                                </Col>

                                            </Row>}
                                            {!hiringFlow.filter_stage && <Row className="ml-0 mr-0">
                                                <Col >
                                                    <p className={styles.noDataMessage}>Details Not Available</p>
                                                </Col>
                                            </Row>}
                                        </Card.Body>
                                    </Card>

                                    {/*  Offer stage */}
                                    <Card className={hiringFlow.offer_stage ? styles.customCardOfferStage : styles.customCardOfferStageDisabled}>
                                        <Card.Header className={hiringFlow.offer_stage ? styles.customCardHeaderOfferStage : styles.customCardHeaderOfferStageDisabled}>
                                            <Col>
                                                <Row>
                                                    <Col sm={5} className="align-self-center">
                                                        <span>OFFER STAGE DETAILS</span>
                                                    </Col>

                                                </Row>
                                            </Col>
                                        </Card.Header>
                                        <Card.Body>
                                            {hiringFlow.offer_stage &&
                                                <div>
                                                    <Row>
                                                        <Col>
                                                            <CustomAlertBox
                                                                alertType="defaultAlert"
                                                                svgStatus="false"
                                                                alertBodyText={
                                                                    <div>
                                                                        <Col>
                                                                            <Row>
                                                                                <p className="mb-1"><span className={styles.stageDescTopicLabels}>Job Title:&nbsp;</span>{hiringFlow.offer_stage.offer_details.job_title ? <span className={styles.stageDescDetailsData}>{hiringFlow.offer_stage.offer_details.job_title}</span> : <span className={styles.criteriaEmpty}>No data to display</span>}</p>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col>
                                                                            <Row>
                                                                                <p className="mb-1"><span className={styles.stageDescTopicLabels}>Allocation:&nbsp;</span>{hiringFlow.offer_stage.offer_details.allocation ? <span className={styles.stageDescDetailsData}>{hiringFlow.offer_stage.offer_details.allocation}</span> : <span className={styles.criteriaEmpty}>No data to display</span>}</p>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col>
                                                                            <Row>
                                                                                <p className="mb-1"><span className={styles.stageDescTopicLabels}>Description:&nbsp;</span>{hiringFlow.offer_stage.offer_details.description ? <span className={styles.stageDescDetailsData}>{hiringFlow.offer_stage.offer_details.description}</span> : <span className={styles.criteriaEmpty}>No data to display</span>}</p>
                                                                            </Row>
                                                                        </Col>
                                                                        <Col>
                                                                            <Row>
                                                                                <p className="mb-1"><span className={styles.stageDescTopicLabels}>Package Reference:&nbsp;</span>{hiringFlow.offer_stage.offer_details.package_reference ? <span className={styles.stageDescDetailsData}>{hiringFlow.offer_stage.offer_details.package_reference}</span> : <span className={styles.criteriaEmpty}>No data to display</span>}</p>
                                                                            </Row>
                                                                        </Col>
                                                                    </div>
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row >


                                                        <Col>
                                                            {(hiringFlow.offer_stage.offer_reviews).length === 0 && <p className={styles.criteriaEmptyBottom}>No reviews to display</p>}
                                                            {(hiringFlow.offer_stage.offer_reviews).map((reValues, index) => (
                                                                <Row className={((hiringFlow.offer_stage.offer_reviews).length === (index + 1)) ? styles.adjustRowMarginsContentWithoutBorder : styles.adjustRowMarginsContent}>
                                                                    <Col key={index}>
                                                                        <Row>
                                                                            <Col md={4}>
                                                                                <p className={styles.userDetailsTopicLabels}>Reviewer Name </p>
                                                                            </Col>
                                                                            <Col>
                                                                                <p className={styles.userDetailsData}>{reValues.reviewer_name}</p>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col md={4}>
                                                                                <p className={styles.userDetailsTopicLabels}>Email </p>
                                                                            </Col>
                                                                            <Col>
                                                                                <p className={styles.userDetailsData}>{reValues.reviewer_email}</p>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col md={4}>
                                                                                <p className={styles.userDetailsTopicLabels}>Status</p>
                                                                            </Col>
                                                                            <Col>

                                                                                {reValues.state == 10 &&
                                                                                    <Alert variant="success" className={styles.badgeType}>Approved</Alert>
                                                                                }
                                                                                {reValues.state == -10 &&
                                                                                    <Alert variant="danger" className={styles.badgeTypeFail}>Rejected</Alert>
                                                                                }
                                                                                {reValues.state == 0 &&
                                                                                    <Alert variant="warning" className={styles.badgeTypeWarning}>Pending</Alert>
                                                                                }

                                                                            </Col>
                                                                        </Row>

                                                                    </Col>
                                                                    <Col>
                                                                        <div>
                                                                            <p className={styles.userDetailsTopicLabels}>Reviewer Comment</p>
                                                                            {(reValues.comments) ?
                                                                                <span className={styles.reviewersComments}><i className="fas fa-circle"></i>&nbsp;{reValues.comments}</span>
                                                                                :
                                                                                <span className={styles.criteriaEmpty} >No comments available</span>
                                                                            }
                                                                        </div>
                                                                    </Col>

                                                                </Row>
                                                            ))}

                                                        </Col>

                                                        <Col lg={2} className={styles.statusRow}>
                                                            {hiringFlow.offer_stage.state == 0 &&
                                                                <Alert variant="warning" className={styles.pendingAlert}>Pending Approval</Alert>
                                                            }
                                                            {hiringFlow.offer_stage.state == 10 &&
                                                                <Alert variant="warning" className={styles.pendingAlert}>Approved</Alert>
                                                            }
                                                            {hiringFlow.offer_stage.state == 20 &&
                                                                <Alert variant="warning" className={styles.pendingAlert}>Offer Sent</Alert>
                                                            }
                                                            {hiringFlow.offer_stage.state == 30 &&
                                                                <Alert variant="success" className={styles.badgeType}>Offer Accepted</Alert>
                                                            }
                                                            {hiringFlow.offer_stage.state == -10 &&
                                                                <Alert variant="danger" className={styles.failAlert}>Approval Rejected</Alert>
                                                            }
                                                            {hiringFlow.offer_stage.state == -20 &&
                                                                <Alert variant="danger" className={styles.failAlert}>Candidate Rejected</Alert>
                                                            }
                                                            {hiringFlow.offer_stage.state == -30 &&
                                                                <Alert variant="danger" className={styles.failAlert}>Offer Retracted</Alert>
                                                            }

                                                        </Col>
                                                    </Row>

                                                    {hiringFlow.offer_stage.candidate_response && (hiringFlow.offer_stage.candidate_response.response_code == -20) &&
                                                        <Col>
                                                            <Row className={styles.failReasonStepBox}>
                                                                <Col>
                                                                    <p className={styles.manualPassFailReasonLabel}>{'Candidate Reject Reason : '}<span className={styles.manuallPassFailReason}>{hiringFlow.offer_stage.candidate_response.reason}</span></p>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    }
                                                    {hiringFlow.offer_stage.offer_retraction_details && (hiringFlow.offer_stage.offer_retraction_details.is_retracted) &&
                                                        <Col>
                                                            <Row className={styles.failReasonStepBox}>
                                                                <Col>
                                                                    <p className={styles.manualPassFailReasonLabel}>{'Offer Retraction Reason: '}<span className={styles.manuallPassFailReason}>{hiringFlow.offer_stage.offer_retraction_details.retracted_reason}</span></p>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    }
                                                </div>
                                            }

                                            {!hiringFlow.offer_stage && <Row className="ml-0 mr-0">
                                                <Col >
                                                    <p className={styles.noDataMessage}>Details Not Available</p>
                                                </Col>
                                            </Row>}
                                        </Card.Body>
                                    </Card>

                                    {/* Hired level */}
                                    <Card className={hiringFlow.hire_stage ? styles.customCardFilterStage : styles.customCardFilterStageDisabled}>
                                        <Card.Header className={hiringFlow.hire_stage ? styles.customCardHeaderFilterStage : styles.customCardHeaderFilterStageDisabled}>
                                            <Col>
                                                <Row>
                                                    <Col sm={5} className="align-self-center">
                                                        <span>HIRED STAGE DETAILS</span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Card.Header>
                                        <Card.Body>
                                            {hiringFlow.hire_stage && <Row className="ml-0 mr-0">
                                                <Col lg={9}>
                                                    <Row>
                                                        <Col md={4}>
                                                            <p className={styles.userDetailsTopicLabels}>Hired Date </p>
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.userDetailsData}>{hiringFlow.hire_stage && hiringFlow.hire_stage.hired_date ? hiringFlow.hire_stage.hired_date : 'Not Available'}</p>
                                                        </Col>
                                                    </Row>
                                                    {hiringFlow.hire_stage && hiringFlow.hire_stage.state === -10 &&
                                                        <Row className={styles.failReasonStepBox}>
                                                            <Col>
                                                                {hiringFlow.hire_stage && hiringFlow.hire_stage.state === -10 ?
                                                                    <p className={styles.manualPassFailReasonLabel}>{'Rejected at Onboarding Reason : '}<span className={styles.manuallPassFailReason}>{hiringFlow.hire_stage.rejected_at_onboarding_reason}</span></p>
                                                                    : null
                                                                }
                                                            </Col>
                                                        </Row>
                                                    }
                                                </Col>
                                                <Col >

                                                </Col>
                                                <Col lg={2} className="align-self-center">
                                                    {hiringFlow.hire_stage && hiringFlow.hire_stage.state === 10 ?
                                                        <Alert variant="success" className={styles.badgeType}>Hired (Pending at Onboarding)</Alert>
                                                        :
                                                        hiringFlow.hire_stage && hiringFlow.hire_stage.state === 30 ?
                                                            <Alert variant="success" className={styles.badgeType}>Hired (Pushed to HRIS)</Alert>
                                                            :
                                                            hiringFlow.hire_stage && hiringFlow.hire_stage.state === -10 ?
                                                                <Alert variant="danger" className={styles.badgeTypeFail}>Rejected at Onboarding</Alert>
                                                                : hiringFlow.hire_stage && hiringFlow.hire_stage.state === 20 ?
                                                                    <Alert variant="success" className={styles.badgeType}>Hired (Onboarded)</Alert>
                                                                    : null
                                                    }
                                                </Col>

                                            </Row>}
                                            {!hiringFlow.hire_stage && <Row className="ml-0 mr-0">
                                                <Col >
                                                    <p className={styles.noDataMessage}>Details Not Available</p>
                                                </Col>
                                            </Row>}
                                        </Card.Body>
                                    </Card>
                                </div>}
                            </Col>
                            <Col md={5} lg={4} xl={3}>
                                <Card className={styles.reviewSubmissionCard}>
                                    <Card.Header className={styles.reviewSubmissionCardHeader}>
                                        <div className={styles.reviewSubmissionCardheaderDetails}>
                                            <p className={styles.reviewSubmissionCardHeaderTopic}>Overall Feedback</p>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        <div>
                                            <span className={styles.overallScoreLabel}>OVERALL SCORE</span>
                                            <div className={styles.scoreBar}>
                                                <div className={styles.overallScoreBar}>
                                                    <CircularProgressbar value={!candidateValues.overall_score ? 0 : candidateValues.overall_score} text={`${!candidateValues.overall_score ? 'N/A' : candidateValues.overall_score + '%'}`}
                                                        styles={{
                                                            text: {
                                                                fontSize: 'var(--app-xx-extra-large-font-size)',
                                                                fontFamily: 'var(--app-primary-font-style)',
                                                                fontWeight: 'var(--app-bold-font-weight)',
                                                                fill: '#2DA6C0'
                                                            },
                                                            path: {
                                                                // Path color
                                                                stroke: `#2DA6C0`,
                                                            },
                                                            trail: {
                                                                // Trail color
                                                                stroke: '#F2F2F2',
                                                            },

                                                        }}
                                                    />

                                                </div>


                                            </div>
                                            {candidateValues.review_criteria.length ?
                                                <div>
                                                    <span className={styles.overallScoreLabel}>Review Criteria</span>
                                                    <div className="mb-3">
                                                        {candidateValues.review_criteria.map((item, i) => (
                                                            <Card className={styles.criteriaBox} key={i}>
                                                                <Card.Body className={styles.criteriaBoxBody}>
                                                                    <span className={styles.criteriaInnerBox}>
                                                                        <span className={styles.criteriaValue}>{item.label}</span>
                                                                        <span><StarRating className="mr-4" disabled={true} id={i} rate={item.rate} /></span>
                                                                    </span>
                                                                </Card.Body>
                                                            </Card>

                                                        ))}
                                                    </div>
                                                </div>
                                                : ''
                                            }
                                           
                                            
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </div>)
            }
        </div >
    )
}

export default ViewSingleCandidate;
